import React from "react";
import { connect } from "react-redux";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import { getUserById } from "../../redux/actions/Users";

class UserPage extends React.Component {
  state = {
    name: ""
  };

  static renderLatestSession(user) {
    if (user.latest_session) {
      return moment(user.latest_session).format("MMM Do");
    } else if (user.last_client_id) {
      return "Too long ago";
    }

    return "Never";
  }

  static renderLastClient(user) {
    if (user.last_client) {
      return (
        <span>
          <br />
          {user.last_client.name}
          <br />
          ID: {user.last_client.id}
          <br />
          Redirect: {user.last_client.redirect}
        </span>
      );
    }

    return "";
  }

  componentWillMount() {
    this.props.getUserById(this.props.userId);
  }

  render() {
    return (
      <div>
        <h1>User</h1>
        <p>{this.props.user.name}</p>
        <p>
          <strong>Username </strong>
          {this.props.user.username}
        </p>
        <p>
          <strong>Last logged in </strong>
          {UserPage.renderLatestSession(this.props.user)}
        </p>
        <div className="row">
          <div className="col-sm-6">
            <strong>Roles</strong>
            <ul>
              {this.props.user.roles.map((role, key) => (
                <li key={key}>
                  <Link to={"/role/" + role.id}>{role.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-sm-6">
            <strong>Permissions</strong>
            <ul>
              {this.props.user.permission.map((permission, key) => (
                <li key={key}>{permission}</li>
              ))}
            </ul>
          </div>
        </div>

        <small>
          <p className="text-muted">
            <strong>GUID </strong>
            {this.props.user.guid}
          </p>
          <p>
            <strong>Last auth driver </strong>
            {this.props.user.last_auth_driver}
          </p>
          <p>
            <strong>Last client </strong>
            {UserPage.renderLastClient(this.props.user)}
          </p>
        </small>
      </div>
    );
  }
}

const mapStateToProps = ({ users }, ownProps) => {
  const userId = ownProps.match.params.id;
  const user = users.find(user => user.id.toString() === userId);

  return { user, userId, users };
};

const mapDispatchToProps = dispatch => {
  return {
    getUserById: userId => {
      return dispatch(getUserById(userId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);



// WEBPACK FOOTER //
// ./src/containers/UserPage/UserPage.js